import { isWeb } from '@commonStyle'
import { StyleSheet, Platform } from 'react-native'

export default StyleSheet.create({
    pageTitle:{
        fontSize: 28,
        color: '#1f2937',
        [isWeb ? '': 'marginBottom'] : 8,
        [isWeb ? '': 'fontWeight']: 'bold',
        [isWeb ? '': 'textAlign']: 'center',
    },
    pageSubtitle: {
        fontSize: 16,
        color: '#6b7280',
        textAlign: 'center',
        marginBottom: 24,
    },
    dateSelector: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 24,
        paddingHorizontal: 20,
    },
    dateText: {
        fontSize: 16,
        color: '#64748b',
        textAlign: 'center',
        fontWeight: '500',
        marginHorizontal: 16,
    },
    dateArrow: {
        padding: 12,
        borderRadius: 8,
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: '#e2e8f0',
        alignItems: 'center',
        justifyContent: 'center',
        marginHorizontal: 16,
        ...Platform.select({
            ios: {
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 2,
            },
            android: {
                elevation: 1,
            },
            web: {
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
            },
        }),
    },
})
